
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[type]",
      function () {
        return require("private-next-pages/[type]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[type]"])
      });
    }
  